<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("WORKS") }}</h1>
      <b-button
        size="sm"
        variant="success"
        class="button-succes-style ml-2 float-right mb-2"
        @click="handleStore"
        ><font-awesome-icon icon="plus-circle" /> {{ $t("NEW") }}
      </b-button>
    </div>

    <storeModalVue @updateList="setup(true)"></storeModalVue>

    <div class="content">
      <div class="content-header">
        <searchBar
          :searchFunc="alltravaux"
          :searchText="$t('WORK_TYPE_SEARCH')"
          :filtre="{
            with_default: filtre_default,
            entreprise: filtre_entreprise ? filtre_entreprise.id : null,
          }"
          :showFiltre="true"
          @returnValue="updateSearch($event)"
        ></searchBar>

        <b-modal id="entrepriseModal" ref="entrepriseModal">
          <template #modal-header="{ close }">
            <h5>{{ $t("COMPANY_ID") }}</h5>
            <b-button size="sm" @click="close()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.028"
                height="17.028"
                viewBox="0 0 17.028 17.028"
              >
                <path
                  id="Icon_material-close"
                  data-name="Icon material-close"
                  d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                  transform="translate(-7.5 -7.5)"
                  fill="#393939"
                />
              </svg>
            </b-button>
          </template>

          <form @submit.prevent="hideModal('entrepriseModal')">
            <div class="center">
              <b-form-group :label="$t('COMPANY_ID')" v-if="isSuperAdmin">
                <searchInput
                  :list="getAllentreprises"
                  :loader="getentrepriseLoading"
                  label="lib"
                  :searchFunc="all_entreprises"
                  @searchfilter="selectentreprise($event)"
                ></searchInput>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox
                  v-model="filtre_default"
                  :value="1"
                  :unchecked-value="0"
                >
                  {{ $t("Afficher les travaux publiques") }}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </form>
          <template #modal-footer>
            <div class="actionModel">
              <b-button variant="success" @click="setup(true)">
                <div class="block-spinner">
                  {{ $t("Appliquer") }}
                </div>
              </b-button>
            </div>
          </template>
        </b-modal>
      </div>
      <div class="filtre">
        <p class="table-count">{{ getTotalRowTravaux }} {{ $t("WORKS") }}</p>
        <div class="productTrie" v-if="currententreprise.lib != null">
          {{ currententreprise.lib }}
          <font-awesome-icon
            icon="times-circle"
            class="icons"
            @click="selectentreprise()"
          />
        </div>

        <div class="productTrie" v-if="currentDefault == 1">
          Voir {{ $t("WORKS") }} publics
          <font-awesome-icon
            icon="times-circle"
            class="icons"
            @click="
              filtre_default = null;
              setup(true);
            "
          />
        </div>
      </div>
      <div class="table-rapport-style w-100">
        <table>
          <thead>
            <tr>
              <th v-if="isSuperAdmin" style="border-radius: 0px 5px 0px 0px">
                {{ $t("SOCIETY") }}
              </th>
              <th>
                {{ $t("PICTURE") }}
              </th>
              <th>
                {{ $t("WORDING") }}
              </th>
              <th style="border-radius: 0px 5px 0px 0px">
                {{ $t("FAVORITE") }}
              </th>
              <th class="action_head"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              role="row"
              class="ligneNormale"
              v-for="(data, i) in computedgetAlltravaux"
              :key="i"
              :class="{ default_element: data.is_default }"
            >
              <td v-if="isSuperAdmin" aria-colindex="1" role="cell">
                {{ data.entreprise.lib }}
              </td>
              <td aria-colindex="1" role="cell">
                <img
                  v-if="data.gallery"
                  class="prodimg"
                  :src="`${galleryUrl}${data.gallery.image}`"
                  alt=""
                />
                <img v-else src="@/assets/noimg.jpg" class="prodimg" alt="" />
              </td>
              <td aria-colindex="2" role="cell">
                <font-awesome-icon
                  icon="fa-solid fa-bookmark"
                  class="icons"
                  v-if="data.is_default"
                />
                {{ data.lib }}
              </td>
              <td aria-colindex="3" role="cell" class="favoris">
                <span class="red" v-if="data.favoris == 1"
                  ><font-awesome-icon icon="heart" style="font-size:18px;width"
                /></span>
              </td>
              <td
                aria-colindex="4"
                role="cell"
                class="action_col"
                v-if="!data.is_default || (data.is_default && isSuperAdmin)"
              >
                <b-button
                  class="button-succes-style"
                  size="sm"
                  variant="danger"
                  @click.prevent.stop="handleDelete(data)"
                >
                  <font-awesome-icon icon="trash" />
                </b-button>
                <b-button
                  class="button-succes-style"
                  size="sm"
                  variant="success"
                  @click.prevent.stop="handleUpdate(data)"
                >
                  <font-awesome-icon icon="pencil-alt" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-modal id="ModelConfigtravaux" ref="ModelConfigtravaux" hide-footer>
        <template #modal-header>
          <h5>{{ $t("EDIT") }} {{ $t("WORKS") }}</h5>
          <b-button size="sm" @click="resetModal()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.028"
              height="17.028"
              viewBox="0 0 17.028 17.028"
            >
              <path
                id="Icon_material-close"
                data-name="Icon material-close"
                d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                transform="translate(-7.5 -7.5)"
                fill="#393939"
              />
            </svg>
          </b-button>
        </template>

        <form @submit.prevent="travauxModalNew" v-if="travauxToConfig">
          <div class="center">
            <b-form-group :label="$t('WORDING')" label-for="lib">
              <b-form-input
                id="lib"
                v-model="v$.travauxToConfig.lib.$model"
                :state="validateState('lib')"
                oninput="this.value = this.value.toUpperCase()"
                aria-describedby="lib-feedback"
              ></b-form-input>
              <error-handle
                :list="v$.travauxToConfig.lib.$errors"
                id="lib-feedback"
              ></error-handle>
              <div v-if="erreurlist.lib" class="error-message">
                <ul v-if="Array.isArray(erreurlist.lib)">
                  <span v-for="(e, index) in erreurlist.lib" :key="index">
                    {{ e }}
                  </span>
                </ul>
                <span v-else>{{ erreurlist.lib }}</span>
              </div>
            </b-form-group>
            <b-form-group :label="$t('GALLERY')">
              <multiselect
                v-model="travauxToConfig.gallery"
                :placeholder="$t('CHOOSE_IMAGE')"
                label="titre"
                track-by="titre"
                :options="getAllgallery"
                :option-height="72"
                :custom-label="customLabel"
                :show-labels="false"
                @search-change="debounceInput2"
                :loading="getLoadinggallery"
                :internal-search="false"
                :close-on-select="true"
              >
                <template slot="singleLabel" slot-scope="props">
                  <div class="option">
                    <span class="option__desc">
                      <span class="option__title">
                        {{ props.option.titre }}
                      </span>
                    </span>
                  </div>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option">
                    <img
                      class="option__image mr-4"
                      :src="`${galleryUrl}${props.option.image}`"
                      alt="None"
                    />
                    <span class="option__desc">
                      <span class="option__title">
                        {{ props.option.titre }}
                      </span>
                    </span>
                  </div>
                </template>
                <template slot="noResult"> {{ $t("NO_DATA_FOUND") }} </template>
              </multiselect>
              <div v-if="erreurlist.gallery_id" class="error-message">
                <ul v-if="Array.isArray(erreurlist.gallery_id)">
                  <span
                    v-for="(e, index) in erreurlist.gallery_id"
                    :key="index"
                  >
                    {{ e }}
                  </span>
                </ul>
                <span v-else>{{ erreurlist.gallery_id }}</span>
              </div>
            </b-form-group>

            <b-form-group :label="$t('COMPANY_ID')" v-if="isSuperAdmin">
              <multiselect
                v-model="travauxToConfig.entreprise"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="computedAllentreprises"
                label="lib"
                track-by="id"
                @search-change="debounceInput3"
                :loading="getentrepriseLoading"
                :internal-search="false"
              >
                <template slot="noResult"> {{ $t("NO_DATA_FOUND") }} </template>
              </multiselect>
              <div v-if="erreurlist.entreprise_id" class="error-message">
                <ul v-if="Array.isArray(erreurlist.entreprise_id)">
                  <span
                    v-for="(e, index) in erreurlist.entreprise_id"
                    :key="index"
                  >
                    {{ e }}
                  </span>
                </ul>
                <span v-else>{{ erreurlist.entreprise_id }}</span>
              </div>
            </b-form-group>
            <b-form-group :label="$t('FAVORITE')" label-for="Favoris">
              <b-form-checkbox
                id="Favoris"
                v-model="travauxToConfig.favoris"
                name="favoris"
                value="true"
                unchecked-value="false"
              >
                {{ $t("FAVORITE") }}
              </b-form-checkbox>
            </b-form-group>
          </div>

          <div class="actionModel">
            <b-alert variant="warning" show v-if="errorU" class="messageError">
              {{ errorU }}
            </b-alert>
            <b-button
              variant="success"
              type="submit"
              class="succes-btn-modal btn-success"
            >
              <div class="block-spinner">
                {{ $t("EDIT") }}
                <div v-if="getLoadingtravaux" class="loading ml-2">
                  <div class="spinner-border" role="status"></div>
                </div>
              </div>
            </b-button>
          </div>
        </form>
      </b-modal>

      <deleteModalVue
        :loader="getLoadingtravaux"
        :elemToDelete="travauxToDelete"
        :elemDelete="delete_travaux"
        @updateList="setup(false)"
      ></deleteModalVue>

      <b-pagination
        v-if="search == ''"
        v-model="page"
        :total-rows="getTotalRowTravaux"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class=""
      ></b-pagination>
      <b-pagination
        v-else
        v-model="page"
        :total-rows="getTotalRowTravaux"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class=""
      ></b-pagination>
    </div>

    <div class="text-center center-spin">
      <b-spinner
        v-if="getLoadingtravaux"
        variant="primary"
        label="Spinning"
        class="big-spin"
      ></b-spinner>
    </div>
    <CommentMarche to="/how-it-work/travaux"></CommentMarche>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { domains } from "@/environment";
import _ from "lodash";
import searchInput from "@/components/ui/searchInput";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength } from "@vuelidate/validators";
import deleteModalVue from "../components/ui/deleteModal.vue";
import storeModalVue from "../components/Ajoutmodel/traveauxmodale.vue";
import searchBar from "../components/ui/searchBar.vue";
import errorHandle from "../components/ui/errorHandle.vue";
import CommentMarche from "../components/commentMarche.vue";

export default {
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  components: {
    searchBar,
    searchInput,
    deleteModalVue,
    storeModalVue,
    errorHandle,
    CommentMarche,
  },
  data() {
    return {
      search: "",
      travauxToConfig: null,
      travauxToDelete: null,
      page: 1,
      perPage: 10,
      galleryUrl: domains.gallery,
      errorD: false,
      errorU: false,
      searchE: "",
      searchBlock: false,
      currententreprise: {
        id: null,
      },
      optionDefault: [
        { value: null, text: this.$t("HIDE_PUBLIC") },
        { value: 1, text: this.$t("SHOW_PUBLIC") },
      ],
      currentDefault: null,
      filtre_default: null,
      filtre_entreprise: {
        id: null,
      },
      erreurlist: {
        lib: null,
        entreprise_id: null,
        gallery_id: null,
      },
    };
  },
  validations() {
    return {
      travauxToConfig: {
        lib: { required, maxLength: maxLength(100) },
      },
    };
  },
  methods: {
    ...mapActions([
      "edit_travaux",
      "alltravaux",
      "delete_travaux",
      "allgallery",
      "all_entreprises",
    ]),

    validateState(name) {
      const { $dirty, $error } = this.v$.travauxToConfig[name];
      return $dirty ? !$error : null;
    },

    customLabel({ title }) {
      return `${title}`;
    },

    updateSearch(s) {
      this.page = 1;
      this.search = s;
    },

    debounceInput2: _.debounce(function (e) {
      this.allgallery({
        search: e,
      });
    }, 500),

    debounceInput3: _.debounce(function (e) {
      this.all_entreprises({
        search: e,
      });
    }, 500),

    selectentreprise(query) {
      if (query) {
        this.filtre_entreprise = query;
      } else {
        this.filtre_entreprise = {
          lib: null,
        };
      }
      this.setup(true);
      this.hideModal("entrepriseModal");
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    resetModal() {
      this.erreurlist = {
        lib: null,
        entreprise_id: null,
        gallery_id: null,
      };
      this.errorU = null;
      this.$refs["ModelConfigtravaux"].hide();
    },
    async searchtravaux() {
      await this.alltravaux({
        search: this.search,
        page: this.page,
        per_page: this.perPage,
        with_default: this.filtre_default,
        entreprise: this.filtre_entreprise.id,
      });
    },
    hideModal(ref) {
      this.$refs[ref].hide();
    },
    handleUpdate(CAT) {
      this.travauxToConfig = { ...CAT };
      this.$refs["ModelConfigtravaux"].show();
    },
    handleDelete(CAT) {
      this.travauxToDelete = { ...CAT };
      this.$root.$emit("bv::show::modal", "ModelDelete");
    },
    async travauxModalNew() {
      const isFormCorrect = await this.v$.travauxToConfig.$error;
      this.erreurlist = {
        lib: null,
        entreprise_id: null,
        gallery_id: null,
      };
      this.errorU = null;
      if (isFormCorrect) return;
      const data = {
        lib: this.travauxToConfig.lib,
        id: this.travauxToConfig.id,
        gallery_id: this.travauxToConfig.gallery
          ? this.travauxToConfig.gallery.id
          : null,
        favoris: this.travauxToConfig.favoris.toString(),
        lang: "fr",
      };
      if (
        this.travauxToConfig.entreprise &&
        this.travauxToConfig.entreprise.id
      ) {
        data.entreprise_id = this.travauxToConfig.entreprise.id;
      }

      await this.edit_travaux(data)
        .then(() => {
          this.hideModal("ModelConfigtravaux");
          this.errorU = null;
        })
        .catch((err) => {
          if (this.isObject(err)) {
            for (const [key, value] of Object.entries(err)) {
              if (this.erreurlist[key] && !this.erreurlist[key]) {
                this.erreurlist[key] = value;
              }
            }
          } else {
            this.errorU = err;
          }
        });
    },

    handleStore() {
      this.$root.$emit("bv::show::modal", "travauxModal");
    },

    pagination(paginate) {
      this.page = paginate;
      this.searchtravaux();
    },

    setup(refresh = false) {
      if (refresh) this.page = 1;
      this.search = null;
      this.currentDefault = this.filtre_default;
      this.currententreprise = this.filtre_entreprise;
      this.$refs["entrepriseModal"].hide();

      if (this.getOnlineUser) {
        if (this.isSuperAdmin) {
          this.alltravaux({
            page: this.page,
            per_page: this.perPage,
            with_default: this.filtre_default,
            entreprise: this.filtre_entreprise.id,
          });
        } else {
          this.alltravaux({
            page: this.page,
            per_page: this.perPage,
            entreprise: this.getOnlineUser.entreprise.id,
            with_default: this.filtre_default,
          });
        }
      }
    },
  },

  mounted() {
    this.setup(true);

    this.allgallery({ page: this.page, per_page: 1000 });
    if (this.isSuperAdmin)
      this.all_entreprises({
        page: this.page,
        per_page: 1000,
        search: this.search,
      });
  },

  computed: {
    ...mapGetters([
      "getAlltravaux",
      "getLoadingtravaux",
      "getTotalRowTravaux",
      "getTabs",
      "getAllgallery",
      "getLoadinggallery",
      "getOnlineUser",
      "getAllentreprises",
      "getentrepriseLoading",
    ]),

    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    computedgetAlltravaux() {
      return this.getAlltravaux;
    },
    computedAllentreprises() {
      var list = [
        {
          lib: "TOUTES LES ENTREPRISES",
          id: 1,
        },
      ];
      if (this.getAllentreprises)
        this.getAllentreprises.forEach((element) => {
          if (element.id != 1) list.push(element);
        });
      return list;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group .icon-balance {
  top: 8px;
}
.body {
  padding: 4px 0;
  box-shadow: 1px 1px 8px #00000019;
  max-height: 60vh;
  overflow: auto;

  ul {
    list-style: none;
    & li {
      padding: 8px 0;
      cursor: pointer;
      background-color: #f8f8f8;
      margin-bottom: 4px;
      color: #000;
      border: none;
      box-shadow: none;
      transition: all 0.2s ease;
      text-align: center;

      &:hover {
        background-color: #28367a;
        color: #fff;
      }
    }
  }
}
.option {
  display: flex;
  align-items: center;
  .option__image {
    background-color: #465081;
    padding: 4px;
    max-height: 42px;
    max-width: 42px;
  }
}
.prodimg {
  padding: 8px;
  background: #465081;
  max-width: 64px;
  max-height: 64px;
}

.content {
  & p {
    font-size: 12px;
    font-weight: 500;
    padding: 3px 0;
    margin: 0;
  }
}
.dropdown-item {
  text-align: center;
}
.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

body {
  background: #fafdff;
}

.actionModel {
  position: relative;
  padding: 15px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .messageError {
    top: 0;
    color: #e4261b;
    margin-bottom: 6px;
    font-size: 12px;
    background-color: #fff;
    border-color: #fff;
  }
  & .block-spinner {
    display: flex;
    justify-content: center;
  }

  & .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
}

.detailClient {
  background-color: #fff;

  box-shadow: 1px 1px 24px #00000019;

  .clientTop {
    padding: 16px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-bottom: 1px solid #707070;

    & .prodimg {
      max-width: 185px;
      max-height: 231px;
    }

    .star {
      color: #ffc400;
      position: absolute;
      top: 12px;
      right: 8px;
      font-size: 30px;
    }
  }

  .clientMid {
    padding: 16px 8px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 1px solid #707070;

    & > div {
      width: 50%;
    }
  }

  .clientBot {
    padding: 16px 8px;
  }

  & h4 {
    color: #28367a;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }

  & p {
    color: #515151;
    font-size: 16px;
    font-weight: 500;
  }
}
.filtre {
  display: flex;
  align-items: center;

  .table-count,
  .productTrie {
    margin-right: 15px;
  }

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}

.image-conteneur {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .block {
    cursor: pointer;
    width: 25%;
    margin-bottom: 16px;
    padding: 15px;
    &:hover {
      background-color: rgba($color: #000, $alpha: 0.1);
    }

    .image-content {
      img {
        width: 100%;
      }
    }

    p {
      margin: 0;
      text-align: center;
      color: #303030;
    }
  }
}
.galerieImage {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 20%;
    max-height: 100px;
  }
}
</style>
